export default __webpack_public_path__ + "static/media/09.0a36d812.jpg";